module.exports = __webpack_public_path__ + "img/AED_EverywhereLogo-name_only.ec8a5c0.jpg";